import axiosInstance from './axios/axiosConfig'
import { endpoints } from './axios/endpoints'
import { applyCategoryPayload } from '../helpers/templateCategories'

/**
 * Load the category and sub-category list from the API, once at start-up.
 * A failure is ignored: the lists bundled in helpers/templateCategories.js
 * stay in use, and the API still validates every save.
 */
export const loadCategories = async () => {
    try {
        const { data } = await axiosInstance.get(
            endpoints.getTemplateCategories,
            { silentErrorToast: true, background: true }
        )
        applyCategoryPayload(data)
    } catch (error) {
        // keep the bundled lists
    }
}
